(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('NewPasswordResetController', NewPasswordResetController);

  /* ngInject */
  function NewPasswordResetController(passwordResetService, sessionService) {

    const vm = this;

    vm.createPasswordReset = createPasswordReset;
    vm.email = '';
    vm.passwordResetSuccessful = false;

    function createPasswordReset() {
      passwordResetService(sessionService.getAuthToken()).save({email: vm.email}, _response => {
        vm.passwordResetSuccessful = true;
      });
    }

  }
})();
